import { STATIC_URL } from 'constants/data'

interface IBannerImage {
  alt: string
  src: string
}

const cardioBannerImgData = {
  alt: 'Фотография доктора',
  src: `${STATIC_URL}/courses/banner-img-cardio.png`,
  unoptimized: true,
}

const neuroBannerImgData = {
  alt: 'Бабушка и дедушка',
  src: `${STATIC_URL}/courses/banner-img-neuro.png`,
  unoptimized: true,
}

const osteoBannerImgData = {
  alt: 'Доктор и пациент',
  src: `${STATIC_URL}/courses/banner-img-osteo.png`,
  unoptimized: true,
}

const cardioGoldBannerImgData = {
  alt: 'Фотография доктора',
  src: `${STATIC_URL}/courses/banner-img-cardio-gold.png`,
  unoptimized: true,
}

const somnologyBannerImgData = {
  alt: 'Фотография доктора',
  src: `${STATIC_URL}/courses/banner-img-somnology.png`,
  unoptimized: true,
}

const gastroBannerImgData = {
  alt: 'Фотография доктора',
  src: `${STATIC_URL}/courses/banner-img-gastro.png`,
  unoptimized: true,
}

const geriatriaBannerImgData = {
  alt: 'Фотография доктора',
  src: `${STATIC_URL}/courses/banner-img-geriatria.png`,
  unoptimized: true,
}

const geriatriaBasicBannerImgData = {
  alt: 'Фотография доктора',
  src: `${STATIC_URL}/courses/banner-img-ger-basic.png`,
}

const modernMethodsDmpBannerImgData = {
  alt: 'Доктор',
  src: `${STATIC_URL}/courses/modern-methods-dmp/banner-img.png`,
  unoptimized: true,
}

export type { IBannerImage }

export {
  cardioBannerImgData,
  neuroBannerImgData,
  osteoBannerImgData,
  cardioGoldBannerImgData,
  gastroBannerImgData,
  geriatriaBannerImgData,
  somnologyBannerImgData,
  geriatriaBasicBannerImgData,
  modernMethodsDmpBannerImgData,
}
